
/**
 * Button with tab styles, which change depending on whether tab is active
 * 
 * @param {function} onClick - button onClick handler
 * @param {Boolean} isActive - if button is active, button is styled differently
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const TabButton = ({ children, onClick, isActive}) => {

    const styles = `font-semibold text-sm py-3 px-6 rounded-t  hover:text-gray-900 border-gray-300 ${isActive ? 'text-gray-700 border-x border-t' : 'text-gray-600 border-b'}`

    return (
        <button onClick={onClick} className={styles}>
            {children}
        </button>
    );
};
